var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.4505 12.6951C17.4505 13.2687 17.2476 13.7584 16.8418 14.1642C16.4359 14.5701 15.9462 14.773 15.3726 14.773H2.90507C2.33148 14.773 1.84176 14.5701 1.43591 14.1642C1.03007 13.7584 0.827148 13.2687 0.827148 12.6951V4.38338C0.827148 4.102 0.927257 3.85849 1.12747 3.65286C1.32769 3.44724 1.5739 3.34442 1.86611 3.34442H9.65832C9.65832 3.21455 9.72055 3.03598 9.84501 2.80871C9.96946 2.58144 10.0912 2.38663 10.2103 2.22429L10.4051 1.96455C10.4808 1.76975 10.6323 1.6047 10.8596 1.46942C11.0869 1.33414 11.325 1.2665 11.5739 1.2665H15.47C15.7297 1.2665 15.9733 1.33414 16.2005 1.46942C16.4278 1.6047 16.5793 1.76975 16.6551 1.96455C17.1854 2.59226 17.4505 3.05221 17.4505 3.34442V12.6951ZM1.5739 0.925591C1.64966 0.730786 1.80117 0.565743 2.02845 0.430461C2.25572 0.29518 2.49382 0.227539 2.74273 0.227539H6.63884C6.89858 0.227539 7.14208 0.29518 7.36936 0.430461C7.59663 0.565743 7.75356 0.730786 7.84014 0.925591L8.61936 2.30546H0.827148L1.5739 0.925591Z",
    fill: "#393839"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/File.df77145930a45f3f4fce5b0200ca3d8d.svg";
export { ForwardRef as ReactComponent };